import * as React from 'react';
import { colors } from '../../../index';

const IconList = ({
  className = '',
  size = '1em',
  color,
  style = {}
}) => {
  const finalStyle = { ...style,
    fill: colors[color],
    color: colors[color]
  };
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 28 25",
    width: size,
    height: size,
    style: finalStyle,
    className: `icon ${className}`
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.659.756v3.33h3.329V.755H.658zm6.658 0v3.33h19.976V.755H7.317zM.66 7.415v3.329h3.329v-3.33H.658zm6.658 0v3.329H22.3v-3.33H7.317zM.66 14.073v3.33h3.329v-3.33H.658zm6.658 0v3.33h19.976v-3.33H7.317zM.66 20.732v3.329h3.329v-3.33H.658zm6.658 0v3.329h18.311v-3.33H7.318z"
  }));
};

export default IconList;